// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1AOdb","notes":"Notes_notes__2FwXQ"};